<div class="dialog-header flex align-items-center">
  <span class="material-symbols-outlined" style="color: #ffcc00">warning</span>
  <span class="ml-3">{{ 'CURRENCY_WARNING.TITLE' | translate }}</span>
  <span class="material-symbols-outlined mr-5 ml-auto clickable" (click)="closeDialog()">close</span>
</div>
<div class="dialog-content-container">
  <div class="currency-warning-content mx-auto">
    <div class="subtext py-6 text-center">{{ 'CURRENCY_WARNING.SUBTEXT' | translate }}</div>

    <div class="currency-table-container flex justify-content-center">
      <div class="col">
        <div>
          <span class="text-label">
            {{ 'CURRENCY_WARNING.TABLE.LBL_CURRENT_CURRENCY_RATE_VERSION_TOTAL' | translate }}
          </span>
          <span class="text-data">{{ totalSalesPriceWithSnapshotExchangeRate() }} {{ versionCurrencyCode() }}</span>
        </div>
      </div>
      <div class="col">
        <div>
          <span class="text-label">
            {{ 'CURRENCY_WARNING.TABLE.LBL_TODAYS_CURRENCY_RATE_VERSION_TOTAL' | translate }}
          </span>
          <span class="text-data">{{ totalSalesPriceWithTodaysExchangeRate() }} {{ versionCurrencyCode() }}</span>
        </div>
      </div>
    </div>

    <div class="ml-3 mr-3">
      <hr />
    </div>

    <div class="currency-table-container flex justify-content-center">
      <div class="col">
        <div>
          <span class="text-label">{{ 'CURRENCY_WARNING.TABLE.LBL_CURRENCY' | translate }}</span>
          <span class="text-data">{{ versionCurrencyCode() }}</span>
        </div>
      </div>
      <div class="col">
        <div>
          <span class="text-label">{{ 'CURRENCY_WARNING.TABLE.LBL_CALCULATED_FROM' | translate }}</span>
          <span class="text-data">SEK</span>
        </div>
      </div>
      <div class="col">
        <div>
          <span class="text-label">{{ 'CURRENCY_WARNING.TABLE.LBL_CALCULATED_DATE' | translate }}</span>
          <span class="text-data">{{ versionCurrencyCalculatedDate() | CoreCompanyDate }}</span>
        </div>
      </div>
      <div class="col">
        <div>
          <span class="text-label">{{ 'CURRENCY_WARNING.TABLE.LBL_RATE_WHEN_CALCULATED' | translate }}</span>
          <span class="text-data">{{ versionCurrencyExchangeRateSnapshot() }}</span>
        </div>
      </div>
      <div class="col">
        <div>
          <span class="text-label">{{ 'CURRENCY_WARNING.TABLE.LBL_RATE_TODAY' | translate }}</span>
          <span class="text-data">{{ latestCurrencyExchangeRate() }}</span>
        </div>
      </div>
    </div>


    <!-- Actions -->
    <div class="pt-6 pb-7 flex justify-content-center action-buttons">
      <p-button [text]="true" class="mr-2 px-6" (onClick)="closeDialog()">
        {{ 'CURRENCY_WARNING.BUTTONS.KEEP_CURRENT_EXCHANGE_RATE' | translate }}
      </p-button>
      <p-button [raised]="true" class="mr-2 px-6" (onClick)="confirmCurrencyChange()">
        {{ 'CURRENCY_WARNING.BUTTONS.UPDATE_EXCHANGE_RATE' | translate }}
      </p-button>
    </div>

  </div>
</div>
